import { Input, Spin } from "@arco-design/web-react";
import "./GroupList.less";
import React, { useEffect, useRef, useState } from "react";
import { IconSearch } from "@arco-design/web-react/icon";
import { getAuthAccountListApi, getAuthGroupApi } from "@/services/YsApi/auto";
import publishStore from "@/stores/publishStore";
import { Menu } from "@arco-design/web-react";
const MenuItem = Menu.Item;
const SubMenu = Menu.SubMenu;
export default function GroupList(props) {
  const { canVisible = true, onClickItem } = props;
  const [groupList, setGroupList] = useState([]);
  const [childrenMap, setChildrenMap] = useState({}); // 存放子级数据
  const [loadingKeys, setLoadingKeys] = useState([]); // 正在加载的 groupId
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState<number>(1); // 当前页数
  const [totalPage, setTotalPage] = useState<number>(0); // 总页数
  const handleSubMenuClick = async (groupId) => {
    if (!childrenMap[groupId] && !loadingKeys.includes(groupId)) {
      setLoadingKeys((prev) => [...prev, groupId]);
      const res = await getAuthAccountListApi({
        id: groupId,
        platform: 1,
        auth_type: 1,
      }); // 请求子级
      setChildrenMap((prev) => ({ ...prev, [groupId]: res?.data?.accounts || [] }));
      setLoadingKeys((prev) => prev.filter((id) => id !== groupId));
    }
  };
  const getList = async (params: any, isInit?: boolean) => {
    const { page = 1, keyword } = params || {};
    setLoading(true);
    const res = await getAuthGroupApi({ page, page_size: 30, keyword });
    setLoading(false);
    if (isInit) {
      setGroupList(res?.data?.items || []);
    } else {
      setGroupList((prev) => [...prev, ...(res?.data?.items || [])]);
    }
    setTotalPage(Math.ceil((+res?.data?.total || 0) / 30));
  };
  // 滚动加载
  const onScroll = (e: any) => {
    const { scrollTop, clientHeight, scrollHeight } = e.target;
    if (scrollTop + clientHeight >= scrollHeight - 10 && currentPage < totalPage) {
      setCurrentPage((prev) => prev + 1);
      getList({ page: currentPage + 1 });
    }
  };
  useEffect(() => {
    getList({ page: 1 }, true);
  }, []);
  return (
    <div
      className="message-group-list"
      style={{
        display: !publishStore.groupVisible && canVisible ? "none" : "block",
        height: "calc(100vh - 142px)",
      }}
    >
      <div className="group-title" />
      <div>
        <Input
          allowClear
          prefix={<IconSearch />}
          placeholder={"搜索客户名称或账号"}
          onPressEnter={(e) => {
            getList({ keyword: e.target.value, page: 1 }, true);
          }}
        />
      </div>
      <Spin loading={loading}>
        <div className="group-list" onScroll={onScroll}>
          <Menu
            accordion
            onClickSubMenu={(key) => {
              handleSubMenuClick(key);
            }}
            style={{ minWidth: 353 }}
          >
            {groupList.map((item, index) => (
              <SubMenu key={item.id} title={item.name}>
                {!childrenMap[item.id] ? (
                  <MenuItem key="loading">
                    <Spin key={index} loading={true}></Spin>
                  </MenuItem>
                ) : childrenMap[item.id].length ? (
                  childrenMap[item.id].map((child, index) => (
                    <MenuItem
                      disabled={child.auth_enabled !== 1}
                      key={`${item.id}-${child.id}`}
                      onClick={() => {
                        onClickItem(child, item.id);
                      }}
                    >
                      <div className="menuitem-info">
                        <img src={child.avatar || ""} alt="" />
                        <div className="menuitem-text">
                          <p>{child.nickname}</p>
                        </div>
                        <div className="menuitem-status">
                          <span style={{ background: child.auth_enabled === 1 ? "#21B347" : "#FF5159" }}></span>
                          <p style={{ color: child.auth_enabled === 1 ? "#21B347" : "#FF5159" }}>
                            {child.auth_enabled === 1 ? "已授权" : "已失效"}
                          </p>
                        </div>
                      </div>
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem key={`loading_${index}`}>
                    <p className="no_datata">暂无数据</p>
                  </MenuItem>
                )}
              </SubMenu>
            ))}
          </Menu>
        </div>
      </Spin>
    </div>
  );
}
